import React from 'react'
import { Emails } from '../Emails'
import { useTenant } from '../context/TenantContext'

export function TenantEmailsTab() {
    const { tenantId, logo } = useTenant()
    return <Emails tenant_id={tenantId} logo={logo} />
}
